<template>
  <report-section title="睡眠分期图">
    <template v-slot:content>
      <div>
        <div
          :id="title"
          :style="`width: 970px; height: ${220 * zoom}px ;zoom:${
            1 / zoom
          };transform:scale(${zoom});transform-origin:0 0`"
        ></div>
      </div>
    </template>
  </report-section>
</template>
          
    <script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import { DateTool } from "@js/date-tool.js";
export default {
  components: {
    ReportSection,
  },

  props: {
    reportDetailModel: Object,
  },

  data() {
    return {
      title: "section-trend-1111chart",
      zoom: 1,
      chart: undefined,
    };
  },

  created() {
    console.log("reportDetailModel", this.reportDetailModel);
  },

  mounted() {
    //解决tooltip偏移问题（结合chart的style）
    const app = document.getElementById("app");
    this.zoom = window.getComputedStyle(app, null).zoom;
    this.chart = this.$echarts.init(document.getElementById(this.title));
    this.drawLine();
  },

  watch: {
    reportDetailModel() {
      this.drawLine();
    },
  },

  methods: {
    drawLine() {
      this.chart.setOption({
        axisPointer: {
          link: [
            {
              xAxisIndex: [0],
            },
          ],
        },
        grid: [
          {
            right: 20,
            left: 60,
            top: 40,
            bottom: 40,
          }
        ],
        xAxis: [
          {
            type: "time",
            axisLine: {
              lineStyle: {
                color: "#BABABA",
              },
            },
            splitLine: {
              show: true,
            },
            gridIndex: 0,
          }
        ],
        yAxis: [
          {
            name: "睡眠分期",
            type: "value",
            min: 0,
            max: 4,
            axisLine: {
              lineStyle: {
                color: "#BABABA",
              },
            },
            axisLabel: {
              formatter: (value) => {
                return this.formattedAxisLabel(value);
              },
            },
            gridIndex: 0,
          }
        ],
        series: [
          {
            name: "睡眠分期",
            type: "line",
            symbol: "none",
            data: this.reportDetailModel.periodTrandArray,
            lineStyle: {
              width: 1,
            },
            color: "#576AD9",
            xAxisIndex: 0,
            yAxisIndex: 0,
            areaStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#fff",
                  },
                  {
                    offset: 1,
                    color: "#576AD9",
                  },
                ],
              },
            },
          }
        ],
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: (params) => {
            return this.formatterToolTip(params);
          },
        },
      });
    },

    formattedAxisLabel(value) {
      switch (value) {
        case 0:
          return "";
        case 1:
          return "D";
        case 2:
          return "L";
        case 3:
          return "R";
        case 4:
          return "W";
        default:
          break;
      }
    },

    formatterToolTip(params) {
      var tip = "";
      params.forEach((item, index) => {
        if (index == 0) {
          const timeStr = DateTool.millisecondTimestampToStr(
            item.data[0],
            "Y_M_D h:m:s"
          );
          tip += timeStr + "<br />";
        }
        const marker = item.marker;
        const seriesName = item.seriesName;
        let value = "";
        if (seriesName == "睡眠分期") {
          switch (item.value[1]) {
            case 1:
              value = "深睡期";
              break;
            case 2:
              value = "浅睡期";
              break;
            case 3:
              value = "眼动期";
              break;
            case 4:
              value = "清醒期";
              break;
            default:
              break;
          }
        } else {
          value = item.value[1];
        }
        let unit = "";
        switch (seriesName) {
          case "血氧饱和度":
            unit = "%";
            break;
          case "脉率":
            unit = "bpm";
            break;
          case "睡眠分期":
            unit = "";
            break;
          default:
            break;
        }
        tip += marker + seriesName + ": " + value + unit + "<br />";
      });
      return tip;
    },
  },
};
</script>
          
<style lang="scss" scoped>


.line-chart {
  @include z-index-2;
  width: 970px !important;
  height: 220px;
  box-sizing: border-box;
}
</style>